/* Rheinkauf – eigener Cookie-Hinweis.
 * Schreibt die Zustimmung ausschließlich über Shopifys Consent-Tracking-API,
 * speichert also nichts eigenes. Erscheint nur, wenn Shopify sagt, dass für
 * diesen Besucher eine Entscheidung nötig ist.
 */
(function () {
  'use strict';

  var T = {
    title: 'Cookies und Ihre Auswahl',
    body:
      'Einige Cookies braucht der Shop, damit der Warenkorb funktioniert und die Seite sicher läuft. ' +
      'Darüber hinaus möchten wir messen, wie der Shop genutzt wird, und Ihnen passende Werbung zeigen – ' +
      'beides nur, wenn Sie einverstanden sind. Ihre Auswahl können Sie jederzeit ändern.',
    policy: 'Datenschutzerklärung',
    policyUrl: '/policies/privacy-policy',
    acceptAll: 'Alle akzeptieren',
    declineAll: 'Nur notwendige',
    settings: 'Einstellungen',
    prefsTitle: 'Welche Cookies dürfen wir verwenden?',
    save: 'Auswahl speichern',
    close: 'Schließen',
    always: 'Immer aktiv',
    footerLink: 'Cookie-Einstellungen',
    groups: [
      {
        key: 'necessary',
        name: 'Notwendig',
        desc: 'Warenkorb, Anmeldung und Sicherheit. Ohne diese Cookies funktioniert der Shop nicht.',
        locked: true
      },
      {
        key: 'analytics',
        name: 'Statistik',
        desc: 'Anonyme Auswertung, welche Seiten aufgerufen werden. Hilft uns, das Sortiment zu verbessern.'
      },
      {
        key: 'marketing',
        name: 'Marketing',
        desc: 'Erlaubt uns, Werbung auszuspielen, die zu Ihren Interessen passt.'
      },
      {
        key: 'preferences',
        name: 'Komfort',
        desc: 'Merkt sich Einstellungen wie zuletzt angesehene Artikel oder Ihre Sprache.'
      }
    ]
  };

  var cp = null;
  var banner = null;
  var prefs = null;
  var lastFocus = null;

  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (html != null) n.innerHTML = html;
    return n;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- Zustimmung schreiben ---------- */

  /* Merkung im Browser: hält nur fest, DASS entschieden wurde – nie, WAS.
     Die Zustimmung selbst liegt allein bei Shopify. */
  var MARK = 'rk_cookie_entschieden';
  var MARK_TAGE = 180;

  function mark() {
    try { localStorage.setItem(MARK, String(Date.now())); } catch (e) { /* egal */ }
  }

  function marked() {
    try {
      var t = parseInt(localStorage.getItem(MARK), 10);
      if (!t) return false;
      return (Date.now() - t) < MARK_TAGE * 86400000;
    } catch (e) { return false; }
  }

  /* Shopify liefert je nach Version 'yes'/'no'/'' oder true/false.
     Beides wird hier auf eine Form gebracht. */
  function readConsent() {
    var out = { analytics: '', marketing: '', preferences: '' };
    var v;
    try { v = cp.currentVisitorConsent() || {}; } catch (e) { return out; }
    Object.keys(out).forEach(function (k) {
      var x = v[k];
      if (x === true || x === 'yes') out[k] = 'yes';
      else if (x === false || x === 'no') out[k] = 'no';
    });
    return out;
  }

  function hasDecision() {
    var c = readConsent();
    return c.analytics !== '' || c.marketing !== '' || c.preferences !== '';
  }

  function apply(consent, done) {
    if (!cp) return;
    var payload = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: !!consent.preferences,
      sale_of_data: !!consent.marketing
    };

    mark();
    window.__rkCookie = window.__rkCookie || {};
    window.__rkCookie.gesendet = payload;

    function fertig(err) {
      if (!done) return;
      window.__rkCookie.fehler = err || null;
      window.__rkCookie.danach = readConsent();
      var f = done;
      done = null;
      if (typeof f === 'function') f();
    }

    try {
      cp.setTrackingConsent(payload, function (err) { fertig(err); });
      setTimeout(function () { fertig('Zeitüberschreitung'); }, 1500);
    } catch (e) {
      fertig((e && e.message) || 'Ausnahme');
    }
  }

  function currentConsent() {
    var c = readConsent();
    return {
      analytics: c.analytics === 'yes',
      marketing: c.marketing === 'yes',
      preferences: c.preferences === 'yes'
    };
  }

  /* ---------- Banner ---------- */

  function buildBanner() {
    var n = el('div', {
      id: 'rk-cookie',
      role: 'dialog',
      'aria-modal': 'false',
      'aria-labelledby': 'rk-cookie-title',
      'aria-describedby': 'rk-cookie-body'
    });

    n.innerHTML =
      '<div class="rk-cookie__inner">' +
        '<div class="rk-cookie__text">' +
          '<h2 id="rk-cookie-title" class="rk-cookie__title">' + esc(T.title) + '</h2>' +
          '<p id="rk-cookie-body" class="rk-cookie__body">' + esc(T.body) + ' ' +
            '<a href="' + T.policyUrl + '">' + esc(T.policy) + '</a>' +
          '</p>' +
        '</div>' +
        '<div class="rk-cookie__btns">' +
          '<button type="button" class="rk-cookie__btn rk-cookie__btn--accept" data-rk-accept>' + esc(T.acceptAll) + '</button>' +
          '<button type="button" class="rk-cookie__btn rk-cookie__btn--decline" data-rk-decline>' + esc(T.declineAll) + '</button>' +
          '<button type="button" class="rk-cookie__link" data-rk-settings>' + esc(T.settings) + '</button>' +
        '</div>' +
      '</div>';

    n.querySelector('[data-rk-accept]').addEventListener('click', function () {
      apply({ analytics: true, marketing: true, preferences: true }, hideBanner);
    });
    n.querySelector('[data-rk-decline]').addEventListener('click', function () {
      apply({ analytics: false, marketing: false, preferences: false }, hideBanner);
    });
    n.querySelector('[data-rk-settings]').addEventListener('click', function () {
      openPrefs();
    });

    return n;
  }

  function showBanner() {
    if (banner) return;
    banner = buildBanner();
    document.body.appendChild(banner);
    requestAnimationFrame(function () { banner.classList.add('is-open'); });
  }

  function hideBanner() {
    if (!banner) return;
    banner.classList.remove('is-open');
    var n = banner;
    banner = null;
    setTimeout(function () { if (n && n.parentNode) n.parentNode.removeChild(n); }, 260);
  }

  /* ---------- Einstellungen ---------- */

  function buildPrefs() {
    var state = currentConsent();

    var rows = T.groups.map(function (g) {
      var on = g.locked ? true : !!state[g.key];
      return '' +
        '<li class="rk-cookie__row">' +
          '<div class="rk-cookie__row-head">' +
            '<span class="rk-cookie__row-name">' + esc(g.name) + '</span>' +
            (g.locked
              ? '<span class="rk-cookie__always">' + esc(T.always) + '</span>'
              : '<label class="rk-cookie__switch">' +
                  '<input type="checkbox" data-rk-group="' + g.key + '"' + (on ? ' checked' : '') +
                    ' aria-label="' + esc(g.name) + '">' +
                  '<span class="rk-cookie__slider" aria-hidden="true"></span>' +
                '</label>') +
          '</div>' +
          '<p class="rk-cookie__row-desc">' + esc(g.desc) + '</p>' +
        '</li>';
    }).join('');

    var n = el('div', { id: 'rk-cookie-prefs' });
    n.innerHTML =
      '<div class="rk-cookie__backdrop" data-rk-close></div>' +
      '<div class="rk-cookie__modal" role="dialog" aria-modal="true" aria-labelledby="rk-cookie-prefs-title">' +
        '<div class="rk-cookie__modal-head">' +
          '<h2 id="rk-cookie-prefs-title">' + esc(T.prefsTitle) + '</h2>' +
          '<button type="button" class="rk-cookie__x" data-rk-close aria-label="' + esc(T.close) + '">&times;</button>' +
        '</div>' +
        '<ul class="rk-cookie__rows">' + rows + '</ul>' +
        '<div class="rk-cookie__modal-foot">' +
          '<button type="button" class="rk-cookie__btn rk-cookie__btn--accept" data-rk-save>' + esc(T.save) + '</button>' +
          '<button type="button" class="rk-cookie__btn rk-cookie__btn--decline" data-rk-accept-all>' + esc(T.acceptAll) + '</button>' +
        '</div>' +
        '<p class="rk-cookie__modal-note"><a href="' + T.policyUrl + '">' + esc(T.policy) + '</a></p>' +
      '</div>';

    n.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-rk-close')) closePrefs();
    });

    n.querySelector('[data-rk-save]').addEventListener('click', function () {
      var picked = {};
      Array.prototype.forEach.call(n.querySelectorAll('[data-rk-group]'), function (i) {
        picked[i.getAttribute('data-rk-group')] = i.checked;
      });
      apply(picked, function () { closePrefs(); hideBanner(); });
    });

    n.querySelector('[data-rk-accept-all]').addEventListener('click', function () {
      apply({ analytics: true, marketing: true, preferences: true }, function () {
        closePrefs(); hideBanner();
      });
    });

    return n;
  }

  function onKey(e) {
    if (e.key === 'Escape') closePrefs();
  }

  function openPrefs() {
    if (prefs) return;
    lastFocus = document.activeElement;
    prefs = buildPrefs();
    document.body.appendChild(prefs);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { prefs.classList.add('is-open'); });
    var first = prefs.querySelector('button, input');
    if (first) first.focus();
    document.addEventListener('keydown', onKey);
  }

  function closePrefs() {
    if (!prefs) return;
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow = '';
    var n = prefs;
    prefs = null;
    n.classList.remove('is-open');
    setTimeout(function () { if (n && n.parentNode) n.parentNode.removeChild(n); }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Dauerhafter Zugang im Fußbereich ---------- */

  function addFooterLink() {
    if (document.querySelector('[data-rk-cookie-footer]')) return;
    var anchor = null;
    var links = document.querySelectorAll('footer a[href*="/policies/privacy-policy"]');
    if (links.length) anchor = links[links.length - 1];
    if (!anchor) return;

    var b = el('button', {
      type: 'button',
      'data-rk-cookie-footer': '',
      'data-rk-settings-footer': '',
      class: anchor.className
    }, esc(T.footerLink));

    b.addEventListener('click', openPrefs);

    if (anchor.parentNode && anchor.parentNode.tagName === 'LI') {
      var li = anchor.parentNode.cloneNode(false);
      li.appendChild(b);
      anchor.parentNode.parentNode.appendChild(li);
    } else if (anchor.parentNode) {
      anchor.parentNode.insertBefore(b, anchor.nextSibling);
    }
  }

  /* ---------- Start ---------- */

  function start() {
    cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp) return;

    addFooterLink();

    // Vorhandene Verweise öffnen die Einstellungen
    document.addEventListener('click', function (e) {
      var t = e.target.closest
        ? e.target.closest('[data-rk-cookie-settings], a[href="#cookie-einstellungen"]')
        : null;
      if (t) { e.preventDefault(); openPrefs(); }
    });

    // Der Hinweis erscheint genau dann, wenn noch keine Entscheidung vorliegt.
    // shouldShowBanner() wird nur noch zur Diagnose mitgeschrieben – es bleibt
    // true, solange Shopify die Zustimmung nicht verbucht hat, und hätte den
    // Hinweis sonst auf jeder Seite erneut gezeigt.
    window.__rkCookie = window.__rkCookie || {};
    try {
      window.__rkCookie.shouldShowBanner = cp.shouldShowBanner();
    } catch (e) {
      window.__rkCookie.shouldShowBanner = 'Fehler: ' + ((e && e.message) || e);
    }
    window.__rkCookie.zustimmung = readConsent();
    window.__rkCookie.gemerkt = marked();

    if (!hasDecision() && !marked()) showBanner();
  }

  function boot() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start);
        } else {
          start();
        }
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
